const toTitleCase = (str: string): string => (
    str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase()
);

export default toTitleCase;
